import { ERpaProcessStatus } from "../interfaces/tipo-sesion";

/* eslint-disable no-unused-vars */
export enum ProcessIdByName {
  create = 1,
  update = 2,
  delete = 3,
}
enum ColorEnum {
  azulBimbo = "#263576",
  RojoBimbo = "#e9082a",
  grisDeshabilitado = "#AFB1BC",
  grisPendiente = "#7F7F7F",
  amarillo = "#f49f0a",
  naranja = "#FF5733",
  verde = "#008f39",
}

export const colorProcessAsistenciaGbuIntegradaRef = new Map<boolean, string>([
  [true, ColorEnum.verde],
]);

export const colorProcessAsistenciaIntegradaSifcaRef = new Map<boolean, string>(
  [[true, ColorEnum.naranja]]
);

export const colorProcessRef: Record<ProcessIdByName, string> = {
  [ProcessIdByName.create]: ColorEnum.azulBimbo,
  [ProcessIdByName.update]: ColorEnum.amarillo,
  [ProcessIdByName.delete]: ColorEnum.grisDeshabilitado,
};

export const colorProcessRpaRef: Record<ERpaProcessStatus, string> = {
  [ERpaProcessStatus.fail]: ColorEnum.RojoBimbo,
  [ERpaProcessStatus.pending]: ColorEnum.grisPendiente,
  [ERpaProcessStatus.success]: ColorEnum.azulBimbo,
};

export const getColorByProcessStatus = (
  status: ProcessIdByName,
  rpaStatus: ERpaProcessStatus,
  asistenciaGbuIntegrada: boolean | null,
  asistenciaIntegradaSifca: boolean | null
): string => {
  // Priority 1: Final status ->  GBU integration
  if (asistenciaGbuIntegrada && rpaStatus === ERpaProcessStatus.success) {
    return (
      colorProcessAsistenciaGbuIntegradaRef.get(true) ?? colorProcessRef[status]
    );
  }

  // Priority 2: second to last status -> SIFCA integration
  if (asistenciaIntegradaSifca && rpaStatus === ERpaProcessStatus.success) {
    return (
      colorProcessAsistenciaIntegradaSifcaRef.get(true) ??
      colorProcessRef[status]
    );
  }

  // Priority 3: Success status on rpa and the current CRUD processes status
  if (rpaStatus === ERpaProcessStatus.success) {
    return colorProcessRef[status];
  }

  // Priority 4: Other RPA statuses
  return colorProcessRpaRef[rpaStatus];
};
